import { SortableElement } from 'react-sortable-hoc';
import { ImageType, type SceneCompareItem } from '@types';
import IconTrash from '@components/icons/IconTrash';
import Image from '@components/Image';
import IconEdit from '@components/icons/IconEdit';
import cn from '@utils/cn';
import { TipWrapper } from '@components/TipWrapper';
import { useCompareItemQuery } from '../utils';
import { $compareSelectedApi } from '../compareStores';

interface Props {
  isSelected?: boolean;
  data: SceneCompareItem;
  onEditClick: (data: SceneCompareItem) => void;
  onDeleteClick: (
    id: SceneCompareItem['id'],
    options: {
      isSelected: boolean;
    }
  ) => void;
}

export const CompareItem = SortableElement(
  ({ data, isSelected = false, onEditClick, onDeleteClick }: Props) => {
    const { isLoading, data: cacheData } = useCompareItemQuery(data);

    const renderContent = () => {
      if (isLoading || !cacheData?.data) return;
      return (
        <>
          <Image
            className="h-16 w-16 flex-shrink-0"
            src={cacheData.data.thumb}
            type={ImageType.thumb}
            size={16}
          />
          <div className="mx-10 truncate" title={data.title}>
            {data.title}
          </div>
          <TipWrapper
            text="编辑"
            className="ml-auto shrink-0"
            placement="bottom"
            size="sm"
          >
            <IconEdit
              onClick={(e) => {
                e.stopPropagation();
                $compareSelectedApi.set(data.id);
                onEditClick(data);
              }}
            />
          </TipWrapper>
          <TipWrapper
            text="删除"
            className="ml-10 shrink-0"
            placement="bottom"
            size="sm"
          >
            <IconTrash
              onClick={(e) => {
                e.stopPropagation();
                onDeleteClick(data.id, { isSelected });
              }}
            />
          </TipWrapper>
        </>
      );
    };

    return (
      <div
        className={cn(
          'mb-10 flex h-30 w-full cursor-pointer select-none items-center rounded bg-black-#28 px-10 text-sm text-white hover:bg-black-#34',
          {
            'ring-1 ring-inset ring-orange': isSelected,
          }
        )}
        onClick={() => {
          $compareSelectedApi.set(data.id);
        }}
      >
        {renderContent()}
      </div>
    );
  }
);
